import SelectTickIcon from "components/icons/SelectTickIcon";

export const CustomOption = ({ innerProps, children, isSelected, isMulti, isDisabled }) => {
  return (
    <div
      data-testid='multiselect-option'
      {...innerProps}
      className={`grid grid-flow-col items-center gap-2 bg-gray-4 px-4 py-[3px] text-sm
        ${isDisabled ? '!cursor-not-allowed text-gray-5' : 'cursor-pointer text-text'}
        ${isSelected && 'font-medium'}
        ${isMulti ? 'gap-2' : 'justify-between'}`}
    >
      {isMulti && (
        <div className={`flex h-6 w-6 items-center justify-center rounded-full ${isSelected ? 'bg-primary' : 'border border-gray-1'} `}>
          {isSelected && (
            <SelectTickIcon
              className='stroke-white stroke-[2px]'
              size='sm'
            />
          )}
        </div>
      )}
      <div className='whitespace-nowrap'>{children}</div>
      {isSelected && !isMulti && <SelectTickIcon className='stroke-primary' />}
    </div>
  );
};
